export default "__VITE_ASSET__0102b923__"